export enum QnAKey {
    OrderRelated = "is_order_related_example",
    ItemRelated = "is_item_related_example",
    AccountRelated = "is_account_related_example",
    PaymentTax = "is_payment_related_example",
    WebstaurantPlus = "is_webstaurantplus_related_example",
    General = "is_general_related_example",
    Returns = "is_returns_related_example",
}
